import { nightPicks } from '@/mocks/home';

export default function NightPicks() {
  return (
    <section id="night" className="bg-background-50 border-t border-foreground-950/10 scroll-mt-16">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="relative w-full h-64 md:h-80 rounded-lg overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Night%20city%20bokeh%20lights%20blurred%20softly%20in%20warm%20amber%20and%20dim%20vermillion%20tones%2C%20quiet%20empty%20street%20at%20late%20night%2C%20moody%20cinematic%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20subtle%20film%20grain%2C%20calm%20restrained%20editorial%20photography&width=1400&height=520&seq=night-picks-2026&orientation=landscape"
              alt="深夜看片氛围场景"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/15 to-transparent" />
            <div className="absolute left-5 bottom-5 text-background-50">
              <p className="text-xs tracking-[0.25em] font-label">深夜档 · 00:00 - 05:00</p>
              <p className="mt-1 font-heading font-bold text-xl md:text-2xl">深夜无聊想刷片</p>
            </div>
          </div>

          <div>
            <p className="text-xs tracking-[0.25em] text-primary-600 font-label">NIGHT · 深夜片单</p>
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
              这个点适合安静看完的几部
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              按时间段整理的夜间片单，画面柔和不刺眼，适合一个人慢慢看，也适合放着当背景音。
            </p>

            <div className="mt-6 border-t border-foreground-950/10">
              {nightPicks.map((pick) => (
                <div
                  key={pick.id}
                  className="flex items-start gap-4 py-4 border-b border-foreground-950/10 hover:bg-background-100/60 transition-colors px-1"
                >
                  <span className="w-14 shrink-0 font-label text-sm text-accent-700 pt-0.5">{pick.time}</span>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950">
                      {pick.title}
                    </h3>
                    <p className="mt-1 text-xs text-foreground-500">{pick.note}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}